import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

const Checkbox = forwardRef(({ label, colorScheme, className, ...props }, ref = null) => {
  return (
    <label className={`apolo-container ${'apolo-container--' + colorScheme} ${className}`}>
      {label}
      <input type="checkbox" {...props} ref={ref} />
      <span className="apolo-checkmark"></span>
    </label>
  )
})

Checkbox.defaultProps = {
  label: '',
  colorScheme: '',
  className: '',
}
Checkbox.propTypes = {
  label: PropTypes.string,
  colorScheme: PropTypes.string,
  className: PropTypes.string,
}

export default Checkbox
